import { sendClickEvent } from "../../analytics/google-analytics";
import { i18n } from "../../i18n";
import { CartItemView } from "../../../types";
import { closeModal } from "./Modal";
import { ProductCartRow } from "./ProductCartRow";
import { PrimaryButton } from "../Buttons/PrimaryButton";
import { SuccessLinkButton } from "../Buttons/SuccessLinkButton";
import { SecondaryLinkButton } from "../Buttons/SecondaryLinkButton";

declare let window: ProductPage;

export interface ProductAddedToCartModalProps {
  cartValid: boolean;
  success: boolean;
  quantity?: number;
  checkoutUrl?: string;
  addedCartItem?: CartItemView | null;
  message?: string;
}

export const ProductAddedToCartModalContent = ({
  cartValid,
  success,
  quantity,
  checkoutUrl,
  message,
  addedCartItem,
}: ProductAddedToCartModalProps) => {
  return (
    <>
      <div class="p-16 tw:pt-0">
        {!success && (
          <>
            <div class="alert alert-danger">{message}</div>
            <section id="added-to-cart-aria-description" class="sr-only">
              {message}
            </section>
          </>
        )}
        {success && (
          <>
            <h2 class="text-center font-weight-light">
              {i18n("product.modal.addedtocart")}
            </h2>
            <section id="added-to-cart-aria-description" class="sr-only">
              {i18n("modal.added-to-cart.success")}
            </section>
            {addedCartItem && (
              <ProductCartRow item={addedCartItem} quantity={quantity} />
            )}
          </>
        )}
      </div>
      <footer class="tw:flex tw:justify-between tw:flex-col-reverse tw:sm:flex-row tw:gap-2">
        <PrimaryButton
          variant="outline"
          onClick={handleContinue}
          testId="add-to-cart-modal-continue-shopping"
        >
          {i18n("product.modal.continueshopping")}
        </PrimaryButton>

        <div class="tw:flex tw:flex-col-reverse tw:sm:flex-row tw:gap-2">
          <SecondaryLinkButton
            href={window.pageUrls.cartUrl}
            onClick={handleViewBasket}
            testId="add-to-cart-modal-view-basket"
            variant="outline"
          >
            {i18n("product.modal.viewbasket")}
          </SecondaryLinkButton>

          {cartValid && checkoutUrl && (
            <SuccessLinkButton
              href={checkoutUrl}
              onClick={handleCheckout}
              testId="add-to-cart-modal-proceed-to-checkout"
            >
              {i18n("cart.summary.checkout")}
            </SuccessLinkButton>
          )}
        </div>
      </footer>
    </>
  );
};

function handleContinue() {
  sendClickEvent("add_to_cart_modal_continue_shopping", "Continue Shopping");
  closeModal();
}

const handleViewBasket = () =>
  sendClickEvent("add_to_cart_modal_view_basket", "View Basket");

const handleCheckout = () =>
  sendClickEvent("add_to_cart_modal_checkout", "Checkout");
